<template>
  <favorite-user :avatar="source.avatar"
              :username="source.username"
              :level="source.level"
              :is-favorite="source.isFavorite"
              :is-blocked="source.blocked"
              :is-bot="source.bot"
              :has-blocked-you="source.hasBlockedYou"
              :is-search-result="source.isSearchResult"
              :points="source.points"
              :rank="source.rank"
              :active="source.active"
              :has-private-profile="source.hasPrivateProfile"/>
</template>

<script>
import FavoriteUser from '@/components/home/users/FavoriteUser';

export default {
  name: 'item-wrapper',
  props: {
    source: Object,
  },
  components: {
    FavoriteUser,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/shared/FavoriteUserWrapper.vue